import { m, type MithrilVNode } from '../mithril';
import { Services } from '../services';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const RootPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.root,
	path: '/',
	auth: { required: false },
	layout: { nav: false, banner: false },
};

export class RootPage extends IkePage {
	constructor() {
		super(RootPageConfig);
	}

	get nodes(): MithrilVNode {
		return m('div', { onupdate: this.redirect, oncreate: this.redirect });
	}

	private redirect() {
		// We check if the user is authenticated
		// so we don't have to do double refresh
		if (Services.User.isAuthenticated) {
			Services.Route.go(IkePageName.map);
		} else {
			Services.Route.go(IkePageName.login);
		}
	}
}
